'use client';

import {
  HeroSection,
  ServicesSection,
  CTASection,
} from '../components';

export default function HomePageClient({ content }) {
  return (
    <>
      {/* Hero Section */}
      <HeroSection
        headline={content.hero.headline}
        subheadline={content.hero.subheadline}
        description={content.hero.description}
        cta={content.hero.cta}
          logo={{
          light: '/images/general/logo-black.png',
          dark: '/images/general/logo-white.png',
          alt: 'Codeschnipsel Logo',
          width: 800,
          height: 240,
        }}
        backgroundImage={null}
        backgroundVideo={content.hero.backgroundVideo}
        fullHeight={true}
        overlayOpacity={0.6}
        alignment="center"
      />

      {/* Services Section */}
      <section className="py-20 md:py-16">
        <ServicesSection
          headline={content.services.headline}
          subheadline={content.services.subheadline}
          items={content.services.items}
          columns={3}
          variant="light"
        />
      </section>

      {/* Features Section */}
      <section className="py-20 md:py-16 bg-white dark:bg-gray-800">
        <div className="container mx-auto px-4 md:px-8 lg:px-12">
          <div className="max-w-2xl text-center mx-auto mb-12 md:mb-16">
            <h2 className="font-heading font-semibold text-3xl md:text-4xl lg:text-5xl mb-4 text-gray-900 dark:text-gray-100">
              {content.features.headline}
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {content.features.items.map((feature, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-accent/10 dark:bg-accent/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl font-semibold text-slate-900 dark:text-gray-100">{index + 1}</span>
                </div>
                <h3 className="font-heading font-semibold text-lg mb-2 text-gray-900 dark:text-gray-100">
                  {feature.title}
                </h3>
                <p className="text-gray-700 dark:text-gray-300 text-md">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 md:py-16 bg-primary text-white mb-8 md:mb-16">
        <CTASection
          headline={content.cta.headline}
          description={content.cta.description}
          button={content.cta.button}
          variant="dark"
          alignment="center"
        />
      </section>
    </>
  );
}